(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["grounded-subscribe-product-card"] && !Shopify.designMode) return;
  try {
    class GroundedSubscribeProduct extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-selling-plan-select]');
      this.price = this.querySelector('[data-subscription-price]');
      this.regularPrice = this.querySelector('[data-regular-price]');
      this.badge = this.querySelector('.grounded-subscribe-product-card__badge');
      this.form = this.querySelector('form');
      this.button = this.querySelector('.grounded-subscribe-product-card__cta');
      this.select?.addEventListener('change', this.handlePlanChange);
      this.form?.addEventListener('submit', this.handleSubmitFeedback);
      this.handlePlanChange();
    }

    disconnectedCallback() {
      this.select?.removeEventListener('change', this.handlePlanChange);
      this.form?.removeEventListener('submit', this.handleSubmitFeedback);
      window.clearInterval(this.cartPoll);
      window.clearTimeout(this.feedbackTimeout);
    }

    getCartCount = () => {
      const cartIcon = document.querySelector('cart-icon');
      const componentCount = Number(cartIcon?.currentCartCount);

      if (Number.isFinite(componentCount)) return componentCount;

      const countElement = document.querySelector('.cart-bubble__text-count');
      const textCount = Number(countElement?.textContent?.trim() || 0);

      if (Number.isFinite(textCount)) return textCount;

      return 0;
    };

    handleSubmitFeedback = () => {
      if (!this.button || this.button.disabled) return;

      const countBeforeAdd = this.getCartCount();
      const startedAt = Date.now();

      this.button.setAttribute('aria-busy', 'true');
      this.button.removeAttribute('data-grounded-added');

      window.clearInterval(this.cartPoll);
      window.clearTimeout(this.feedbackTimeout);

      this.cartPoll = window.setInterval(() => {
        const currentCount = this.getCartCount();

        if (currentCount <= countBeforeAdd) {
          if (Date.now() - startedAt > 5000) {
            window.clearInterval(this.cartPoll);
            this.button?.removeAttribute('aria-busy');
          }
          return;
        }

        window.clearInterval(this.cartPoll);
        this.showAddSuccess();
      }, 100);
    };

    showAddSuccess = () => {
      if (!this.button) return;

      this.button.removeAttribute('aria-busy');
      this.button.setAttribute('data-grounded-added', 'true');

      const cartDrawer = document.getElementById('cart-drawer');
      const cartTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');

      if (cartDrawer && !cartDrawer.hasAttribute('open')) {
        cartTrigger?.click();
      }

      this.feedbackTimeout = window.setTimeout(() => {
        this.button?.removeAttribute('data-grounded-added');
      }, 1400);
    };

    handlePlanChange = () => {
      const option = this.select?.selectedOptions?.[0];
      if (!option) return;

      if (this.price) this.price.textContent = option.dataset.price || '';
      if (this.regularPrice) this.regularPrice.textContent = option.dataset.regularPrice || '';

      if (this.badge) {
        const saving = option.dataset.saving || '';
        this.badge.textContent = saving ? `SAVE ${saving}` : '';
        this.badge.hidden = !saving;
      }
    };
  }

  if (!customElements.get('grounded-subscribe-product')) {
    customElements.define('grounded-subscribe-product', GroundedSubscribeProduct);
  }
  } catch(e) { console.error(e); }
})();

})();
